import { NodeWithChildren } from '../types';

export const isNodeWithChildren = (
  node: BaseNode
): node is NodeWithChildren => {
  return 'children' in node;
};
